import { Skeleton } from '@mui/material';
import { HEADER_HEIGHT } from '../../constants/layout';

const LoadingSkeleton = () => {
  return (
    <div className='flex bg-[#f9f8f8]'>
      <Skeleton component='div' variant='rectangular' sx={{ width: '270px', height: '100vh' }} />
      <div className='flex w-full flex-col'>
        <Skeleton component='div' variant='rectangular' sx={{ width: '100%', height: HEADER_HEIGHT }} />
        {Array.from({ length: 4 }).map((_, i) => {
          return <Skeleton key={i} component='div' variant='rounded' sx={{ margin: '30px', height: '25%' }} />;
        })}
      </div>
    </div>
  );
};

export default LoadingSkeleton;
